import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const AllCategoriesPromotedPage = withCompass(
  () => import("../../pages/AllCategoriesPromotedPage")
);
const SearchAdsGridPage = withCompass(
  () => import("../../pages/SearchAdsGridPage")
);
const SearchPopoutCarouselsPage = withCompass(
  () => import("../../pages/SearchPopoutCarouselsPage")
);

export function UzairAshrafRoutes() {
  return (
    <Switch>
      <Route
        path="/ua/all-categories-promoted"
        component={AllCategoriesPromotedPage}
      />
      <Route path="/ua/search-ads-grid" component={SearchAdsGridPage} />
      <Route
        path="/ua/search-popout-carousels"
        component={SearchPopoutCarouselsPage}
      />
    </Switch>
  );
}

export const slug = "ua";
